import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"

interface ScrollSnapChangeEvent extends Event {
  snapTargetInline: HTMLElement
}

export default class extends Controller {
  static targets = ["link"]
  static values = {
    fromSnap: { type: Boolean, default: false }
  }

  declare readonly linkTargets: HTMLElement[]
  declare fromSnapValue: boolean

  connect() {
    this.element.addEventListener("scrollsnapchange", this.handleScroll.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("scrollsnapchange", this.handleScroll.bind(this))
  }

  click(event: Event) {
    const link = event.currentTarget as HTMLElement
    link.closest(".snap-center")?.scrollIntoView({ 
      behavior: "smooth", 
      block: "nearest", 
      inline: "center" 
    })

    this.fromSnapValue = true
  }

  private handleScroll(event: Event) {
    const snapEvent = event as ScrollSnapChangeEvent
    const link = snapEvent.snapTargetInline.querySelector("a")
    if (!link) return

    if (!this.fromSnapValue) {
      visit(link.getAttribute("href") || "", { frame: "photo_preview" })
    }
    this.fromSnapValue = false
  }
} 